import { t } from 'i18next';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { InputComponent } from '@shopeasy-dashboard-ui/ui-library';
import TextareaComponent from '../FormInput/TextareaComponent';

const ShowFaq = () => {
  const location = useLocation();
  const { elem } = location.state || {};
  return (
    <>
      <div className='flex items-end justify-between bg-white absolute top-[80px] z-40 w-full overflow-auto pb-2'>
        <h4 className='text-xl md:text-2xl font-medium ps-3 text-semibold text-center'>
          {t('lang_Show_FAQ')}
        </h4>
      </div>
      <div className='pt-[128px] p-5 overflow-x-hidden w-full primary-bg-color rounded-[6px] h-full'>
        <div className='p-4'>
          <div className='w-1/2 mx-auto border bg-white border-gray-300 rounded-[6px]'>
            <div className='relative flex flex-col min-w-0 break-words bg-white p-5 w-full rounded-[6px]'>
              <div className='flex-auto'>
                <div className='tab-content tab-space space-y-4'>
                  <div id='link1' className='space-y-4'>
                    <div>
                      <InputComponent
                        id='question'
                        name='question'
                        label={t('lang_Question')}
                        value={elem?.question || ''}
                        disabled={true}
                      />
                    </div>
                    <div>
                      <TextareaComponent
                        id='answer'
                        name='answer'
                        label={t('lang_Answer')}
                        value={elem?.answer || ''}
                        disabled={true}
                        rows={10}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowFaq;
